module.exports = __webpack_public_path__ + "static/media/royal_super.bd963541.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pepino/climasense/mildiu_pepino/curativa/royal_super.png
// module id = 2114
// module chunks = 3